import { toast as c } from "react-hot-toast";
async function e(p, r, o = r("public_pages_purchase.copy_clipboard")) {
  try {
    if (!document.hasFocus())
      throw new Error();
    await navigator.clipboard.writeText(p), o && c.success(o);
  } catch {
    c.error(r("public_pages_purchase.copy_clipboard_error"));
  }
}
export {
  e as copyTextToClipboard
};
